import YesNoConfirmation from "Components/yesNoConfirmation/yesNoConfirmation";
import classNames from "classnames";
import React, { memo, useCallback, useMemo } from "react";
import ButtonWithTooltip from "../buttonWithTooltip";
import locale from "./refreshButton.locale";
import { Button } from "UiKit";
function RefreshButton(props) {
    const handleRefresh = useCallback(() => {
        props.onRefresh && props.onRefresh();
    }, [props.onRefresh]);
    const innerBtn = useMemo(() => props.useNewBtn ? (React.createElement(Button, { styleType: "text", size: "32", onClick: !props.needConfirm ? handleRefresh : undefined, disabled: props.disabled, iconOnly: true, tooltipMessage: locale.REFRESH },
        React.createElement("i", { className: "icon-refresh" }))) : (React.createElement(ButtonWithTooltip, { width: props.btnSize, height: props.btnSize, className: classNames("no-border", props.className), disabled: props.disabled, popoverContent: locale.REFRESH, onClick: !props.needConfirm ? handleRefresh : undefined },
        React.createElement("i", { className: "icon-refresh" }))), [
        props.btnSize,
        props.useNewBtn,
        props.className,
        props.disabled,
        handleRefresh,
        props.needConfirm
    ]);
    return props.needConfirm && !props.disabled ? (React.createElement(YesNoConfirmation, { onConfirm: props.onRefresh, title: locale.REFRESH_CONFIRM_TEXT, description: locale.REFRESH_CONFIRM_DESCRIPTION, position: props.confirmPosition }, innerBtn)) : (innerBtn);
}
export default memo(RefreshButton);
RefreshButton.defaultProps = {
    btnSize: 28,
    confirmPosition: {
        my: "left top",
        at: {
            x: "left",
            y: "bottom"
        }
    }
};
